export interface WPPost {
  id: number;
  slug: string;
  date: string;
  title: {
    rendered: string;
  };
  excerpt: {
    rendered: string;
  };
  content: {
    rendered: string;
  };
  _embedded?: any;
}

const API_URL = "https://wp.drnehaagarwalonco.com/wp-json/wp/v2";

export async function getPosts(page = 1): Promise<WPPost[]> {
  const response = await fetch(
    `${API_URL}/posts?_embed&per_page=9&page=${page}&t=${Date.now()}`,
    {
      method: "GET",
      cache: "no-store",
    }
  );

  if (!response.ok) {
    throw new Error(
      `Failed to fetch posts. Status: ${response.status}`
    );
  }

  const data: WPPost[] = await response.json();

  console.log("POSTS =", data);

  return data;
}

export async function getPostBySlug(
  slug: string
): Promise<WPPost | null> {
  const response = await fetch(
    `${API_URL}/posts?slug=${encodeURIComponent(slug)}&_embed`,
    {
      method: "GET",
      cache: "no-store",
    }
  );

  if (!response.ok) {
    throw new Error(
      `Failed to fetch post. Status: ${response.status}`
    );
  }

  const data: WPPost[] = await response.json();

  console.log("POST =", data);

  return data.length ? data[0] : null;
}